import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@ptg-shared/shared.module';
import { ControlsModule } from '@ptg-shared/controls/controls.module';
import { DocumentListViewComponent } from './pages/document-list-view/document-list-view.component';
import { IndividualDocumentListComponent } from './pages/individual-document-list/individual-document-list.component';
import { FileEffects } from './store/effects';
import { TagService } from './services';
import { fileReducers } from './store/reducers';
import { OverviewHeaderEntityModule } from '@ptg-member/components/overview-header-entity/overview-header-entity.module';
import { EmployerOverviewHeaderModule } from '@ptg-employer/components/employer-overview-header/employer-overview-header.module';
import { DocumentsService } from './services/documents.service';
import { MODULE_KEY } from './constants';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentViewCurrentFilterComponent } from './components/document-view-current-filter/document-view-current-filter.component';
import { DocumentPreviewComponent } from 'src/app/admin/features/file/components/document-preview/document-preview.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { GeneratedDocumentComponent } from 'src/app/admin/features/file/pages/generated-document/generated-document.component';
import { VitalReportModalComponent } from './components/vital-report-modal/vital-report-modal.component';
import { LifeStatus360ReportModalComponent } from './components/lifestatus-360-report-modal/lifestatus-360-report-modal.component';
import { SursReciprocalReportModalComponent } from './components/surs-reciprocal-report-modal/surs-reciprocal-report-modal.component';
import { DatePipe } from '@angular/common';

const COMPONENTS = [
  DocumentListViewComponent,
  IndividualDocumentListComponent,
  DocumentViewCurrentFilterComponent,
  DocumentPreviewComponent,
  GeneratedDocumentComponent,
  VitalReportModalComponent,
  LifeStatus360ReportModalComponent,
  SursReciprocalReportModalComponent
];
const EFFECTS = [...FileEffects];
const SERVICES = [
  TagService,
  DocumentsService,
  DatePipe,
];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ControlsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(MODULE_KEY, fileReducers),
    EffectsModule.forFeature(EFFECTS),
    OverviewHeaderEntityModule,
    EmployerOverviewHeaderModule,
    NgxExtendedPdfViewerModule,
  ],
  exports: [
    DocumentListViewComponent,
    IndividualDocumentListComponent,
    DocumentPreviewComponent,
    GeneratedDocumentComponent,
    VitalReportModalComponent,
    LifeStatus360ReportModalComponent,
    SursReciprocalReportModalComponent
  ],
  providers: [...SERVICES],
})
export class FileSharedModule {
}
